import moment from 'moment/moment';
import { ClickableCellRenderer } from '../../../../../components/AGGrid/cell-renderers/clickable';
import {CustomHeader} from "../../../../../components/AGGrid/cell-renderers/custom-header";

export const id = {
    field: 'id',
    headerName: 'ID',
    cellRenderer: 'agGroupCellRenderer',
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'id',
        page: 'sections',
    }
};

export const name = {
    field: 'title',
    headerName: 'Name',
    tooltipField: 'title',
    flex: 4,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'title',
        page: 'sections',
    }
};

export const type = {
    field: 'sectionType.sectionName',
    headerName: 'Type',
    flex: 3,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'sectionType.sectionName',
        page: 'sections',
    }
};

export const createdBy = {
    field: 'createdBy.username',
    headerName: 'Created By',
    tooltipField: 'createdBy.username',
    flex: 3,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'createdBy.username',
        page: 'sections',
    }
};
export const linked = (onOpenSSProductsModal) => ({
    field: 'productIdList.length',
    headerName: 'Linked',
    cellRenderer: ClickableCellRenderer(onOpenSSProductsModal, 'fa-link'),
    flex: 2,
});

export const created = {
    headerName: 'Created',
    tooltipField: 'createdAt',
    valueGetter: (data) => {
        return data?.data.createdAt && moment(data.data.createdAt).format('MM/DD/YYYY');
    },
    flex: 2,
    headerComponent: CustomHeader,
    headerComponentParams: {
        colId: 'createdAt',
        page: 'sections',
    }
};

export const edit = (onOpenSSModal) => ({
    valueGetter: (unused) => {
        return 'EDIT';
    },
    cellRenderer: ClickableCellRenderer(onOpenSSModal, 'fa-pencil'),
    flex: 2,
});
